export default "__VITE_ASSET__CgY89QGD__"